import { ImageElement } from '@kontent-ai/gatsby-components';
import { type ImageItem } from '@kontent-ai/gatsby-components/dist/image-element';
import 'react-medium-image-zoom/dist/styles.css';

import ImageZoom from '@/components/ImageZoom';

const Image = (props?: ImageItem) => {
  if (!props?.url) {
    return <span />;
  }

  const { description, width } = props;

  return (
    <figure>
      <ImageZoom width={width}>
        <ImageElement image={props} alt={description ?? undefined} />
      </ImageZoom>
    </figure>
  );
};

export default Image;
